// import { MathfieldElement } from "mathlive";
// import "mathlive/static.css"; // or your mathlive CSS import

// export default class MathEditor {
//     static get isReadOnlySupported() {
//         return true;
//     }

//     static get enableLineBreaks() {
//         return true;
//     }

//     static get toolbox() {
//         return {
//             title: "Math Editor",
//             icon: `<svg viewBox="0 0 24 24" fill="currentColor">
//         <text x="2" y="18" font-size="16" font-family="serif">∑</text>
//       </svg>`,
//         };
//     }

//     static get DEFAULT_PLACEHOLDER() {
//         return "e=mc^2";
//     }

//     static get DEFAULT_TYPE() {
//         return "cdx-math-success";
//     }

//     static get MATH_TYPES() {
//         return [
//             "primary", "secondary", "info", "success",
//             "warning", "danger", "light", "dark", "pink", "choco",
//         ];
//     }

//     get CSS() {
//         return {
//             settingsButton: this.api.styles.settingsButton,
//             settingsButtonActive: this.api.styles.settingsButtonActive,
//             wrapper: "cdx-math",
//             wrapperForType: (type) => `cdx-math-${type}`,
//         };
//     }

//     constructor({ data, config, api, readOnly, block }) {
//         console.log("data, config, api, readOnly, block:", data, config, api, readOnly, block);

//         this.api = api;
//         this.readOnly = readOnly;
//         this.block = block; // ← capture block reference

//         this.data = {
//             type: data?.type || MathEditor.DEFAULT_TYPE,
//             latex: data?.latex || "",
//         };

//         this.onMathChange = config?.onMathChange;
//         this.config = {
//             // virtualKeyboardMode: config?.virtualKeyboardMode || "manual",
//             // defaultMode: config?.defaultMode || "math",
//             // smartMode: config?.smartMode ?? false,
//             // virtualKeyboardTheme: config?.virtualKeyboardTheme || "material",
//         };

//         this.mfe = this._createMathfield();
//     }

//     _createMathfield() {
//         const mfe = new MathfieldElement();
//         mfe.setValue(this.data.latex);
//         mfe.classList.add(this.data.type);

//         if (this.readOnly) {
//             mfe.setOptions({
//                 virtualKeyboardMode: "off",
//                 defaultMode: "inline-math",
//                 readOnly: true,
//             });
//             return mfe;
//         }

//         // mfe.setOptions({
//         //     virtualKeyboardMode: this.config.virtualKeyboardMode,
//         //     defaultMode: this.config.defaultMode,
//         //     smartMode: this.config.smartMode,
//         //     readOnly: false,
//         //     virtualKeyboardTheme: this.config.virtualKeyboardTheme,
//         // });
//         mfe.addEventListener("focus", () => {
//             requestAnimationFrame(() => {
//                 mfe.executeCommand("showVirtualKeyboard");
//             });
//         });

//         mfe.addEventListener("input", () => {
//             console.log("input");

//             this.data.latex = mfe.getValue();
//             clearTimeout(this.saveTimer);

//             this.saveTimer = setTimeout(() => {
//                 this.onMathChange?.();
//             }, 500);
//         });

//         mfe.addEventListener("move-out", (ev) => {
//             ev.preventDefault();
//             mfe.blur();
//         });

//         mfe.addEventListener("focus-out", (ev) => {
//             ev.preventDefault();
//             if (ev.detail.direction === "forward") {
//                 mfe.executeCommand("moveToMathfieldEnd");
//             } else if (ev.detail.direction === "backward") {
//                 mfe.executeCommand("moveToMathfieldStart");
//             }
//         });

//         return mfe;
//     }
//     _notifyEditorChange() {
//         try {
//             // Custom event that bubbles up to the editor container
//             const event = new CustomEvent("math-input", { bubbles: true });
//             this.mfe.dispatchEvent(event);

//             if (this.block?.id) {
//                 this.api.blocks.update(this.block.id, {
//                     latex: this.data.latex,
//                     type: this.data.type,
//                 });
//             }
//         } catch (e) {
//             console.warn("MathEditor: failed to notify editor change", e);
//         }
//     }


//     // Color theme picker in the block settings panel
//     renderSettings() {
//         const container = document.createElement("div");

//         MathEditor.MATH_TYPES.forEach((type) => {
//             const btn = document.createElement("div");
//             btn.classList.add(
//                 this.CSS.wrapper,
//                 this.CSS.settingsButton,
//                 this.CSS.wrapperForType(type)
//             );
//             btn.innerHTML = "M";

//             if (this.data.type === this.CSS.wrapperForType(type)) {
//                 btn.classList.add(this.CSS.settingsButtonActive);
//             }

//             btn.addEventListener("click", () => {
//                 // Swap color class on the mathfield element
//                 this.mfe.classList.remove(this.data.type);
//                 this.data.type = this.CSS.wrapperForType(type);
//                 this.mfe.classList.add(this.data.type);

//                 // Update active highlight in settings
//                 container
//                     .querySelectorAll(`.${this.CSS.settingsButton}`)
//                     .forEach((b) => b.classList.remove(this.CSS.settingsButtonActive));
//                 btn.classList.add(this.CSS.settingsButtonActive);
//             });

//             container.appendChild(btn);
//         });

//         return container;
//     }

//     render() {
//         return this.mfe;
//     }

//     save() {
//         console.log("saving math editor");

//         return {
//             type: this.data.type,
//             latex: this.mfe?.getValue() ?? this.data.latex,
//         };
//     }

//     validate(savedData) {
//         return typeof savedData.latex === "string" && savedData.latex.trim().length > 0;
//     }

//     static get conversionConfig() {
//         return {
//             export: (data) => data.latex,
//             import: (string) => ({
//                 latex: string,
//                 type: MathEditor.DEFAULT_TYPE,
//             }),
//         };
//     }

//     static get sanitize() {
//         return {
//             type: false,
//             latex: true,
//         };
//     }
// }




import { MathfieldElement } from "mathlive";
// import "mathlive/static.css";

export default class MathEditor {
    static get isReadOnlySupported() {
        return true;
    }

    static get enableLineBreaks() {
        return true;
    }

    static get toolbox() {
        return {
            title: "Math Editor",
            icon: `<svg viewBox="0 0 24 24" fill="currentColor">
                <text x="2" y="18" font-size="16" font-family="serif">∑</text>
            </svg>`,
        };
    }

    static get DEFAULT_TYPE() {
        return "cdx-math-success";
    }

    static get MATH_TYPES() {
        return [
            "primary",
            "secondary",
            "info",
            "success",
            "warning",
            "danger",
            "light",
            "dark",
            "pink",
            "choco",
        ];
    }

    get CSS() {
        return {
            settingsButton: this.api.styles.settingsButton,
            settingsButtonActive: this.api.styles.settingsButtonActive,
            wrapper: "cdx-math",
            wrapperForType: (type) => `cdx-math-${type}`,
        };
    }

    constructor({ data, config, api, readOnly }) {
        this.api = api;
        this.readOnly = readOnly;

        this.data = {
            type: data?.type || MathEditor.DEFAULT_TYPE,
            latex: data?.latex || "",
        };

        this.onMathChange = config?.onMathChange;

        this.mfe = this._createMathfield();
    }

    _createMathfield() {
        const mfe = new MathfieldElement();

        mfe.setValue(this.data.latex);
        mfe.classList.add(this.data.type);

        if (this.readOnly) {
            mfe.setOptions({
                readOnly: true,
                virtualKeyboardMode: "off",
            });

            return mfe;
        }

        // for backspace and arrow errors
        // mfe.addEventListener(
        //     "keydown",
        //     (e) => {
        //         if (
        //             e.key === "Backspace" ||
        //             e.key === "Delete" ||
        //             e.key.startsWith("Arrow")
        //         ) {
        //             console.log("hi");
        //             e.stopPropagation();
        //         }
        //     },
        //     true // capture phase
        // );
        mfe.addEventListener("keydown", (e) => {
            if (
                e.key === "Backspace" ||
                e.key === "Delete" ||
                e.key.startsWith("Arrow")
            ) {
                e.stopPropagation();
            }
        });

        mfe.addEventListener("input", () => {
            this.data.latex = mfe.getValue();

            clearTimeout(this.saveTimer);

            this.saveTimer = setTimeout(() => {
                this.onMathChange?.();
            }, 500);
        });

        return mfe;
    }

    render() {
        return this.mfe;
    }

    save() {
        return {
            type: this.data.type,
            latex: this.mfe?.getValue() ?? this.data.latex,
        };
    }

    validate(savedData) {
        return (
            typeof savedData.latex === "string" &&
            savedData.latex.trim().length > 0
        );
    }

    renderSettings() {
        const container = document.createElement("div");

        MathEditor.MATH_TYPES.forEach((type) => {
            const btn = document.createElement("div");

            btn.classList.add(
                this.CSS.wrapper,
                this.CSS.settingsButton,
                this.CSS.wrapperForType(type)
            );

            btn.innerHTML = "M";

            if (this.data.type === this.CSS.wrapperForType(type)) {
                btn.classList.add(this.CSS.settingsButtonActive);
            }

            btn.addEventListener("click", () => {
                this.mfe.classList.remove(this.data.type);

                this.data.type = this.CSS.wrapperForType(type);

                this.mfe.classList.add(this.data.type);

                container
                    .querySelectorAll(`.${this.CSS.settingsButton}`)
                    .forEach((el) =>
                        el.classList.remove(this.CSS.settingsButtonActive)
                    );

                btn.classList.add(this.CSS.settingsButtonActive);
            });

            container.appendChild(btn);
        });

        return container;
    }

    static get conversionConfig() {
        return {
            export: (data) => data.latex,
            import: (latex) => ({
                latex,
                type: MathEditor.DEFAULT_TYPE,
            }),
        };
    }

    static get sanitize() {
        return {
            type: false,
            latex: true,
        };
    }
}